import apiService from "../../services/api.service";
import { Sample } from "../../assets/images";
import { createSlice } from "@reduxjs/toolkit";
import { createApiCase } from "../../helpers/create.api.case";
import { createApiThunk } from "../../helpers/create.api.thunk";

export const getOrderList = createApiThunk(
  "getOrderList",
  apiService.getOrderList
);

export const initialData = {
  orderListLoading: false,
  orderList: [
    // {
    //   id: "334902461",
    //   date: "16 Feb 2025 12:03 PM",
    //   status: "pending",
    //   total_item: 2,
    //   subtotal: 220.0,
    //   shipping: 0,
    //   tax: 0,
    //   total: 220.0,
    //   items: [
    //     {
    //       id: 1,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //     {
    //       id: 2,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //   ],
    // },
    // {
    //   id: "334902460",
    //   date: "14 Feb 2025 13:05 PM",
    //   status: "delivered",
    //   total_item: 2,
    //   subtotal: 220.0,
    //   shipping: 0,
    //   tax: 0,
    //   total: 220.0,
    //   items: [
    //     {
    //       id: 1,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //     {
    //       id: 2,
    //       image: Sample,
    //       label: "Black T-Shirt & Trouser",
    //       option: "White | 2XL",
    //       price: 110.0,
    //       quantity: 1,
    //     },
    //   ],
    // },
  ],
};

const dataSlice = createSlice({
  name: "order",
  initialState: initialData,
  reducers: {},
  extraReducers: (builder) => {
    createApiCase(builder, getOrderList, {
      loading: "orderListLoading",
      fulfilled: (state, action) => {
        state.orderList = action.payload.data.aaData;
      },
    });
  },
});

export const {} = dataSlice.actions;

export default dataSlice.reducer;
